import { AppUtil } from 'kuaidong-lib'

export class ALog {
  static async json(app: string, key: string, payload: any): Promise<any> {
    const params = {
      app,
      key,
      content: {
        ...payload,
        url: location.href,
      },
    }

    return AppUtil.httpPOST('/client_log', params, {}, true)
  }
}
